import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import { LaWarningComponent } from "../../warning-popups/la-warning/la-warning.component";
import {MatDialog} from "@angular/material/dialog";

@Component({
    selector: 'app-weave-true-false',
    templateUrl: './weave-true-false.component.html',
    styleUrls: ['./weave-true-false.component.scss'],
    standalone: false
})
export class WeaveTrueFalseComponent implements OnInit {
  @Input() label: string;
  @Input() data: boolean;
  @Input() disabledFlag: boolean; //todo make disable!
  @Input() warning: string = "";

  @Output() focusOut: EventEmitter<Boolean> = new EventEmitter<Boolean>();

  item:{ isChecked: Boolean } = {isChecked: false};
  id: string = "";
  constructor(
    private Dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.item.isChecked = this.data;
    this.id = "weave-true-false-" + uuidv4();
  }

  sendValue() {
    this.item.isChecked = !this.item.isChecked;
    this.focusOut.emit(this.item.isChecked);
  }
  changeValue(event) {
    if(this.warning) { //show warning first
      const dialogRef = this.Dialog.open( LaWarningComponent, {
        panelClass: 'la-warning-message',
        width: '540px',
        data: {
          errorMessages: [ this.warning ],
          hasCancel: true
        }
      } );
      dialogRef.afterClosed().subscribe( result => {
        if( result ) {
          this.sendValue();
        } else {
          console.log(this.item)
        }
      } );
    } else {
      this.sendValue();
    }
  }

  undo() {
    //todo make it undo the changes
  }

}
